// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-containers-App-Progress-styles--normal--kwUMS {
  display: block;
  text-align: center;
  transition: transform 0.6s ease;
}

@media (prefers-reduced-motion) {

.src-containers-App-Progress-styles--normal--kwUMS {
    transition: none;
}
  }

.src-containers-App-Progress-styles--hidden--puxO9 {
  display: none;
}

.src-containers-App-Progress-styles--loader--k7jLm {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #000;
}

@media (max-width: 640px) {

.src-containers-App-Progress-styles--loader--k7jLm {
    left: 0;
    width: 100%;
    transform: translate(0, -50%);
}
  }

.src-containers-App-Progress-styles--wrapper--VoCEa {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
  height: 120px;
}

.src-containers-App-Progress-styles--wrapper--VoCEa i {
    display: block;
    font-size: 7.4rem;
    color: #000;
  }

.src-containers-App-Progress-styles--alter--oH4uo {
  transition: stroke-dasharray 0.6s ease, stroke-dashoffset 0.6s ease;
}

.src-containers-App-Progress-styles--inner--wJz3M {
  left: 0;
  position: absolute;
  top: 39px;
  width: 100%;
  height: 50px;
}

.src-containers-App-Progress-styles--inner--wJz3M svg {
    height: 40px;
  }
`, "",{"version":3,"sources":["webpack://./src/containers/App/Progress/styles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;EAClB,+BAA+B;AAKjC;;AAHE;;AALF;IAMI,gBAAgB;AAEpB;EADE;;AAGF;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;AAOb;;AALE;;AAPF;IAQI,OAAO;IACP,WAAW;IACX,6BAA6B;AAEjC;EADE;;AAGF;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;AAOf;;AALE;IACE,cAAc;IACd,iBAAiB;IACjB,WAAW;EACb;;AAGF;EACE,mEAAmE;AACrE;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;AAKd;;AAHE;IACE,YAAY;EACd","sourcesContent":[".normal {\n  display: block;\n  text-align: center;\n  transition: transform 0.6s ease;\n\n  @media (prefers-reduced-motion) {\n    transition: none;\n  }\n}\n\n.hidden {\n  display: none;\n}\n\n.loader {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #000;\n\n  @media (max-width: 640px) {\n    left: 0;\n    width: 100%;\n    transform: translate(0, -50%);\n  }\n}\n\n.wrapper {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 120px;\n  height: 120px;\n\n  & i {\n    display: block;\n    font-size: 7.4rem;\n    color: #000;\n  }\n}\n\n.alter {\n  transition: stroke-dasharray 0.6s ease, stroke-dashoffset 0.6s ease;\n}\n\n.inner {\n  left: 0;\n  position: absolute;\n  top: 39px;\n  width: 100%;\n  height: 50px;\n\n  & svg {\n    height: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"normal": `src-containers-App-Progress-styles--normal--kwUMS`,
	"hidden": `src-containers-App-Progress-styles--hidden--puxO9`,
	"loader": `src-containers-App-Progress-styles--loader--k7jLm`,
	"wrapper": `src-containers-App-Progress-styles--wrapper--VoCEa`,
	"alter": `src-containers-App-Progress-styles--alter--oH4uo`,
	"inner": `src-containers-App-Progress-styles--inner--wJz3M`
};
module.exports = ___CSS_LOADER_EXPORT___;
